import { useState, useEffect, useMemo } from 'react';
import { usePortfolio } from '../context/PortfolioContext';

const AutoTyping = ({ roles: propRoles }) => {
  const [text, setText] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);
  const [loopNum, setLoopNum] = useState(0);
  const [typingSpeed, setTypingSpeed] = useState(150);
  const { portfolioData } = usePortfolio();

  // Memoize roles to avoid unnecessary resets
  const roles = useMemo(() => {
    let r = propRoles !== undefined ? propRoles : (portfolioData.profile?.roles || []);
    if (!Array.isArray(r) || r.length === 0) {
      r = ["AI Engineer", "Freelancer", "YouTuber", "Innovator"];
    }
    return r;
  }, [JSON.stringify(propRoles !== undefined ? propRoles : (portfolioData.profile?.roles || []))]);

  // Reset animation state when roles change
  useEffect(() => {
    setText('');
    setIsDeleting(false);
    setLoopNum(0);
  }, [roles]);

  useEffect(() => {
    if (!roles.length) return;

    const currentRole = roles[loopNum % roles.length];
    let delay = 150;

    if (isDeleting) {
      delay = 30;
    }

    if (!isDeleting && text === currentRole) {
      delay = 500; // Pause before deleting
    } else if (isDeleting && text === '') {
      delay = 200; // Pause before typing next role
    }

    const timer = setTimeout(() => {
      if (!isDeleting && text !== currentRole) {
        setText(currentRole.substring(0, text.length + 1));
      } else if (!isDeleting && text === currentRole) {
        setIsDeleting(true);
      } else if (isDeleting && text !== '') {
        setText(currentRole.substring(0, text.length - 1));
      } else if (isDeleting && text === '') {
        setIsDeleting(false);
        setLoopNum((prev) => prev + 1);
      }
    }, delay);

    return () => clearTimeout(timer);
  }, [text, isDeleting, loopNum, roles]);

  return (
    <span className="text-primary">
      {text}
      <span className="animate-blink">|</span>
    </span>
  );
};

export default AutoTyping; 